var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M100 34.375l-9.375-9.375-40.625 40.625-40.625-40.625-9.375 9.375 50 50 50-50z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }